import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";

const NewsletterSignup = () => {
  return (
    <Container className="bg-white shadow-lg rounded">
      <Row className="align-items-center">
        {/* Left Side - Image */}
        <Col md={6} className="p-0">
          <img
            src="/images/background.jpg"
            alt="Yoga Pose"
            className="img-fluid rounded-start w-100 h-100"
            style={{ objectFit: "cover" }}
          />
        </Col>

        {/* Right Side - Signup Form */}
        <Col md={6} className="text-center py-4 signupInputs">
          {/* Icon */}
          <div className="mb-3">
            <img
                src="/images/logo.svg"
                alt="wengmack"
                className="img-fluid rounded nav-logo"
              />
          </div>

          {/* Title & Subtitle */}
          <h2 className="fw-bold">Try us!</h2>
          <p className="text-muted">Sign up for our newsletter or use the whatsapp link</p>

          {/* Email Signup Form */}
          <Form>
            <Form.Group className="mb-3">
              <Form.Control
                type="email"
                placeholder="Enter your email"
                className="text-center"
              />
            </Form.Group>
            <Button href="/signUP" variant="primary" className="w-100">
                Signup
            </Button>
          </Form>

          {/* WhatsApp Newsletter Link */}
          <a
            href="https://wa.me/+254725646496"
            target="_blank"
            rel="noopener noreferrer"
            className="d-block mt-3 text-success fw-semibold"
          >
            <i class="bi bi-whatsapp"></i> Join via WhatsApp
          </a>
        </Col>
      </Row>
    </Container>
  );
};

export default NewsletterSignup;
